module.exports = __webpack_public_path__ + "static/media/Pratyush Vaishnavi.5912fae7.png";